import React from "react";
import { useParams } from "react-router-dom";
import { Box, IconButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "axios";
// import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";


const FileView = () => {
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    var fileName = urlParams.get('fileName')
    const { fileId, userId } = useParams();
    const fileUrl = `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/access/${fileId}?userId=${userId}`;

    const handleDownload = async () => {
        try {
            const response = await axios({
                method: 'get',
                url: `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/download/${fileId}`,
                responseType: 'blob' // Important for file downloads
            });

            // Create a download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            // Set filename based on resource type
            const filename = fileName;
            link.setAttribute('download', filename);

            // Trigger download
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download error:', error);
        }
    };

    return (
        <Box
            sx={{
                width: "100vw",
                height: "100vh",
                bgcolor: "#000",
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                outline: "none",
                "&:focus": {
                    outline: "none",
                },
            }}
        >
            <IconButton
                onClick={handleDownload}
                sx={{
                    position: "absolute",
                    top: 16,
                    right: 16,
                    zIndex: 10,
                    color: "#fff",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                    },
                }}
            >
                <DownloadIcon fontSize="medium" />
            </IconButton>

            <img
                src={fileUrl}
                alt="Preview"
                style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                }}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = ""; // Optional fallback
                }}
            />
        </Box>
    );
};

export default FileView;
